import { AdObj, NativeAdObj, CsmAdObj } from '../../shared/types/ast';

export function isMediation(adObj: AdObj): adObj is CsmAdObj {
    if (adObj.source === 'csm') {
        return true;
    }
    return false;
}

export function isNative(adObj: AdObj): adObj is NativeAdObj {
    return adObj.adType === 'native' && adObj.source === 'rtb';
}
